import type { Article } from "@/types/content";

export const articles: Article[] = [
  {
    slug: "insider-channel-chain",
    title: "拆解一条“内部渠道”的完整链路：从话术到成交",
    subtitle: "所谓内部渠道，往往只是被精心设计的信息差",
    excerpt:
      "“内部名额”“最后一批”“系统还没更新”……这些话术为什么总能奏效？我们把一条典型的“内部渠道”拆成七个节点，看看信息差究竟是在哪一步被制造出来的。",
    channel: "industry",
    author: "沈默",
    publishedAt: "2026-09-10",
    readMinutes: 8,
    tags: ["行业内幕", "信息差", "话术拆解"],
    views: 12840,
    featured: true,
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20noir%20still%20life%20of%20a%20sealed%20brown%20envelope%20and%20scattered%20documents%20on%20a%20dark%20desk%20under%20a%20single%20warm%20desk%20lamp%2C%20deep%20shadows%2C%20crimson%20and%20amber%20tones%2C%20moody%20editorial%20photography%2C%20abstract%20investigative%20atmosphere%2C%20high%20detail%2C%20no%20text%2C%20no%20faces&width=1200&height=750&seq=cover-insider-channel-01&orientation=landscape",
    content: [
      {
        type: "p",
        text: "在大多数交易里，买卖双方掌握的公开信息其实是接近的。真正拉开差距的，是那个被反复强调的“别人不知道”。于是，只要有人愿意相信“你拿到的是内部渠道”，价格就失去了锚点，判断也失去了参照。",
      },
      {
        type: "h2",
        text: "第一个节点：制造稀缺",
      },
      {
        type: "p",
        text: "链路通常从一句“这批就这么多”开始。稀缺本身不构成欺骗，但当稀缺没有任何可验证的来源时，它就成了一种情绪工具。它让人从“要不要买”切换到“能不能抢到”。",
      },
      {
        type: "quote",
        text: "真正值钱的信息，从来不需要用“内部”两个字来包装。",
      },
      {
        type: "h2",
        text: "中间的四个节点：身份、对比、时间与担保",
      },
      {
        type: "list",
        items: [
          "身份：把说话的人放进一个无法被核实的角色里，比如“前员工”“合作方”。",
          "对比：用一个虚高的“外面价格”衬托出不存在的优惠幅度。",
          "时间：用倒计时压缩决策时间，让人来不及去做交叉验证。",
          "担保：用一句“出了问题找我”替代本该存在的书面约定。",
        ],
      },
      {
        type: "p",
        text: "这四个节点很少同时出现，通常只取其中两三个组合。这也解释了为什么很多人事后回想，会觉得“当时也说不上哪里不对”。",
      },
      {
        type: "h2",
        text: "最后两个节点：闭环与沉没成本",
      },
      {
        type: "p",
        text: "成交之后，链路并不会立刻结束。常见的收尾方式是把你拉进一个“老客户群”，用群体氛围完成二次加固。等到事情出现问题时，你投入的时间、精力和“已经介绍给朋友”的沉没成本，反而成了阻止你说出口的那道墙。",
      },
      {
        type: "p",
        text: "看清这条链路，并不意味着要怀疑一切。它只是提醒我们：任何把决策压力从“信息”转移到“情绪”上的环节，都值得停下来多想一分钟。",
      },
    ],
  },
  {
    slug: "hotsearch-how-made",
    title: "热搜是怎么被制造出来的：一条内容的完整旅程",
    subtitle: "从一条小内容到榜单位置，中间经过了谁",
    excerpt:
      "同一个话题，为什么有时悄无声息，有时却能连续占据榜单？我们把一条内容从发布到冲上榜单的过程还原出来，看看热度究竟是由什么推动的。",
    channel: "internet",
    author: "周叙",
    publishedAt: "2026-09-08",
    readMinutes: 7,
    tags: ["网络迷雾", "流量链路", "信息分辨"],
    views: 9630,
    featured: true,
    cover:
      "https://readdy.ai/api/search-image?query=moody%20dark%20abstract%20visualization%20of%20glowing%20network%20nodes%20and%20thin%20connecting%20lines%20floating%20in%20deep%20shadow%2C%20crimson%20and%20amber%20light%20accents%2C%20cinematic%20editorial%20tech%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1200&height=750&seq=cover-hotsearch-journey-01&orientation=landscape",
    content: [
      {
        type: "p",
        text: "热度从来不是自然现象。它更像一股被多方同时推着走的水流，方向由许多只手共同决定。理解这一点，比记住某一次榜单位置更有价值。",
      },
      {
        type: "h2",
        text: "起点：情绪先于事实到位",
      },
      {
        type: "p",
        text: "能快速扩散的内容，通常不是信息量最大的，而是情绪最容易转述的。一句可以被原样复述的话，往往比一段需要理解的解释传播得更远。",
      },
      {
        type: "h2",
        text: "中段：被反复“结构化”",
      },
      {
        type: "list",
        items: [
          "标题被截取成更短、更冲突的版本；",
          "配图从原图换成更有冲击力的截图；",
          "评论区被少数高赞观点定下基调；",
          "时间线被省略，只保留最有戏剧性的一段。",
        ],
      },
      {
        type: "quote",
        text: "当一件事只能用一个句子概括时，它通常已经被加工过了。",
      },
      {
        type: "h2",
        text: "终点：热度退潮，标签留下",
      },
      {
        type: "p",
        text: "榜单会更新，但被贴上的标签往往留得更久。对读者而言，最实用的做法是：在看到高热内容时，先去找那个被省略的时间线，再决定要不要转发。",
      },
    ],
  },
  {
    slug: "merger-three-way",
    title: "一场并购背后的三方博弈：谁在悄悄改价",
    subtitle: "价格不是谈出来的，是被结构出来的",
    excerpt:
      "一桩看似顺利的并购，为什么在最后阶段突然出现价格波动？从公开信息和行业惯例出发，我们梳理出买方、卖方与中间方在谈判桌上的三种典型动作。",
    channel: "business",
    author: "林砚",
    publishedAt: "2026-09-05",
    readMinutes: 9,
    tags: ["商业暗流", "并购", "博弈"],
    views: 7420,
    cover:
      "https://readdy.ai/api/search-image?query=dramatic%20low-key%20photo%20of%20stacked%20ledgers%20and%20a%20fountain%20pen%20on%20dark%20wood%20desk%2C%20single%20warm%20beam%20of%20light%2C%20deep%20shadow%2C%20cinematic%20editorial%20still%20life%2C%20amber%20and%20crimson%20tones%2C%20abstract%20business%20mystery%2C%20high%20detail%2C%20no%20text&width=1200&height=750&seq=cover-merger-negotiation-01&orientation=landscape",
    content: [
      {
        type: "p",
        text: "并购的公开版本通常平稳而克制：双方握手，团队合并，业务协同。但只要把时间线拉长，就会发现价格往往在成交前的最后几周才真正定型。",
      },
      {
        type: "h2",
        text: "买方：用时间换价格",
      },
      {
        type: "p",
        text: "买方最常使用的筹码不是钱，而是时间。延长尽职调查、提出新的合规问题、要求补充盈利预测，每一个动作都会让卖方的心理价位发生松动。",
      },
      {
        type: "h2",
        text: "卖方：用备选方案换空间",
      },
      {
        type: "list",
        items: [
          "引入第二个意向方，制造竞价氛围；",
          "把核心资产单独拆分，重新设定估值口径；",
          "对外释放扩张信号，抬高自身的谈判位势。",
        ],
      },
      {
        type: "h2",
        text: "中间方：用信息节奏换位置",
      },
      {
        type: "p",
        text: "财务顾问、律师与行业中介掌握着信息发布的节奏。谁能决定“什么时候让谁知道什么”，谁就在无形中影响价格。这也是为什么同一笔交易，不同角色事后讲述的版本会截然不同。",
      },
      {
        type: "quote",
        text: "价格从来不只是数字，它是一组关于“谁更急”的判断。",
      },
      {
        type: "p",
        text: "对旁观者来说，与其关注最终公告里的那个数字，不如关注它是如何在时间、备选与信息节奏中被一点点塑造出来的。",
      },
    ],
  },
  {
    slug: "price-war-loop",
    title: "为什么有些行业总在“价格战”里打转",
    subtitle: "降价是策略，还是被结构困住的必然",
    excerpt:
      "有些行业每隔几年就会集体陷入低价竞争，参与者都清楚这不是出路，却没人敢先停手。我们试着从成本结构、渠道集中度与用户比价习惯三个角度解释这种循环。",
    channel: "business",
    author: "林砚",
    publishedAt: "2026-09-02",
    readMinutes: 6,
    tags: ["商业暗流", "价格战", "成本结构"],
    views: 5180,
    cover:
      "https://readdy.ai/api/search-image?query=moody%20abstract%20photo%20of%20a%20diminishing%20row%20of%20identical%20objects%20receding%20into%20darkness%20under%20a%20single%20warm%20light%2C%20deep%20shadows%2C%20crimson%20accent%20glow%2C%20cinematic%20editorial%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1200&height=750&seq=cover-price-war-loop-01&orientation=landscape",
    content: [
      {
        type: "p",
        text: "价格战最反直觉的地方在于：几乎所有参与者都知道它伤利润，却依然不敢退出。这不是判断力问题，而是结构问题。",
      },
      {
        type: "h2",
        text: "成本结构：固定成本越高，越难停手",
      },
      {
        type: "p",
        text: "当一次投入的固定成本很高、边际成本很低时，多卖一件的诱惑会盖过整体利润的考量。于是降价成了“至少先把产能填满”的本能反应。",
      },
      {
        type: "h2",
        text: "渠道集中度：谁掌握比价入口",
      },
      {
        type: "list",
        items: [
          "当购买决策大量发生在一个能直接比价的入口时，价格会被推到最显眼的位置；",
          "渠道自身的排序规则，会放大小幅降价带来的曝光差异；",
          "于是“别人降了我也得降”从猜测变成了可被验证的事实。",
        ],
      },
      {
        type: "h2",
        text: "用户习惯：被训练出来的预期",
      },
      {
        type: "p",
        text: "长期的低价促销会重塑用户的支付预期。一旦用户默认“等等看会打折”，原价就失去了可信度，行业便更难回到正常定价。",
      },
      {
        type: "p",
        text: "打破循环的方式通常不在价格里，而在于是否有企业愿意用不可替代的差异重新定义比较的维度。",
      },
    ],
  },
  {
    slug: "old-town-night-rule",
    title: "老城区深夜食堂的“潜规则”",
    subtitle: "一条街的作息，藏着城市最真实的秩序",
    excerpt:
      "凌晨两点还在营业的小馆子，看起来只是生意，其实有一套稳定运行多年的规则。从收摊时间到座位安排，我们记录了老城区夜宵街里那些不成文的默契。",
    channel: "city",
    author: "顾迟",
    publishedAt: "2026-08-29",
    readMinutes: 7,
    tags: ["都市奇谈", "城市观察", "夜宵街"],
    views: 6890,
    cover:
      "https://readdy.ai/api/search-image?query=moody%20dark%20alley%20at%20night%20with%20wet%20cobblestones%20reflecting%20warm%20amber%20streetlight%2C%20fog%20and%20deep%20shadows%2C%20cinematic%20editorial%20photography%2C%20crimson%20glow%20accents%2C%20abstract%20urban%20mystery%20atmosphere%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=1200&height=750&seq=cover-night-food-street-01&orientation=landscape",
    content: [
      {
        type: "p",
        text: "白天属于写字楼和商场，深夜属于另一套秩序。老城区的夜宵街在凌晨反而更清醒，这里的规则不写在墙上，却比招牌更管用。",
      },
      {
        type: "h2",
        text: "收摊时间：不是随意的",
      },
      {
        type: "p",
        text: "同一条街上的几家馆子，收摊时间往往刻意错开。错开既是避免同时熄灯带来的冷清，也是多年形成的默契：谁先走，谁留最后。",
      },
      {
        type: "h2",
        text: "座位安排：熟客优先是默认",
      },
      {
        type: "list",
        items: [
          "靠墙的位置留给常客，视野好但不容易被注意；",
          "门口的位置留给过路人，翻台更快；",
          "拼桌是常态，但拼桌的对象有讲究，通常按同行与否分开。",
        ],
      },
      {
        type: "quote",
        text: "一条街的秩序，不靠规定维持，靠的是每个人都知道别人会怎么做。",
      },
      {
        type: "p",
        text: "这些规则不会出现在任何官方文件里，却决定了这条街几十年来的稳定。理解它们，也就理解了城市夜晚的另一面。",
      },
    ],
  },
  {
    slug: "ledger-city-change",
    title: "一份旧账本里的城市变迁",
    subtitle: "数字背后，是一座城市口味的迁移史",
    excerpt:
      "在一家即将搬迁的老店库房里，我们翻到一摞上世纪的手写账本。价格、品种与来客构成的变化，比任何总结都更直观地记录了一座城市的变迁。",
    channel: "history",
    author: "苏晚",
    publishedAt: "2026-08-26",
    readMinutes: 8,
    tags: ["历史暗影", "城市记忆", "旧物"],
    views: 4310,
    cover:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20an%20aged%20handwritten%20ledger%20with%20faded%20ink%20rows%20on%20a%20dark%20table%2C%20single%20warm%20light%20from%20the%20side%2C%20deep%20shadows%2C%20amber%20and%20sepia%20tones%2C%20cinematic%20editorial%20still%20life%2C%20abstract%20archive%20atmosphere%2C%20no%20text&width=1200&height=750&seq=cover-old-ledger-archive-01&orientation=landscape",
    content: [
      {
        type: "p",
        text: "账本是最诚实的历史文本之一。它不表达观点，只记录发生了什么、花了多少、谁来过。正因为如此，字里行间的变化才格外有说服力。",
      },
      {
        type: "h2",
        text: "价格栏：通货膨胀之外的另一种信号",
      },
      {
        type: "p",
        text: "同一件商品的价格在十几年里的变化并不平滑。有些年份纹丝不动，有些年份连续上调，这些节点往往与更大的经济背景暗中对应。",
      },
      {
        type: "h2",
        text: "品种栏：口味跟着人口走",
      },
      {
        type: "list",
        items: [
          "早期品种单一，供应稳定；",
          "中期出现大量新条目，对应外来人口流入；",
          "后期条目收缩，回归少数几个经典款。",
        ],
      },
      {
        type: "p",
        text: "账本不会解释为什么，但它会诚实地留下证据。把这些证据和时间线对照起来，一座城市的迁移史便慢慢显影。",
      },
    ],
  },
  {
    slug: "founder-silent-years",
    title: "聚光灯之外：一个创业者的沉默三年",
    subtitle: "在被反复讨论之前，那段时间几乎无人提及",
    excerpt:
      "关于一个创业者的故事，常被压缩成“成功”或“失败”两个版本。我们更想聊聊中间那三年——既没有高光，也没有结论，却决定了他后来所有的选择。",
    channel: "people",
    author: "沈默",
    publishedAt: "2026-08-22",
    readMinutes: 7,
    tags: ["人物观察", "创业", "转身"],
    views: 5760,
    cover:
      "https://readdy.ai/api/search-image?query=solitary%20silhouette%20of%20a%20person%20seen%20from%20behind%20at%20a%20dark%20window%20at%20night%2C%20warm%20amber%20reflections%2C%20deep%20shadows%2C%20cinematic%20editorial%20mood%2C%20abstract%20contemplative%20atmosphere%2C%20high%20detail%2C%20no%20recognizable%20face&width=1200&height=750&seq=cover-silent-founder-01&orientation=landscape",
    content: [
      {
        type: "p",
        text: "我们习惯用结果去理解一个人。于是他成功，就回看每一步都是伏笔；他失败，就回看每一步都是冒进。可真实的过程，往往既没有伏笔，也没有结论。",
      },
      {
        type: "h2",
        text: "沉默的开始：先关掉对外解释",
      },
      {
        type: "p",
        text: "那三年里他几乎不再接受采访，也很少更新动态。不是因为没什么可说，而是他发现，一旦开始解释，就会忍不住去迎合别人期待的版本。",
      },
      {
        type: "h2",
        text: "中间的重构：把问题拆小",
      },
      {
        type: "list",
        items: [
          "先把现金流这一件事稳住，其他都可以等；",
          "把团队缩到最小，只保留能直接面对用户的人；",
          "停止扩张，用半年把产品重做一遍。",
        ],
      },
      {
        type: "quote",
        text: "最难的不是做选择，而是在没人看见的时候，依然按自己的标准做事。",
      },
      {
        type: "p",
        text: "后来他重新出现在公众视野里，被解读成“王者归来”或“第二曲线”。但对他自己而言，那三年并不是过渡，而是全部。",
      },
    ],
  },
  {
    slug: "iq-tax-review",
    title: "复盘六种常见“智商税”套路",
    subtitle: "它们卖的不是产品，是一种被制造出来的确定感",
    excerpt:
      "为什么有些产品明明功能平平，却能卖得很好？通过复盘六种典型套路，我们试着说明：多数“智商税”卖的不是功能，而是对不确定性的安慰。",
    channel: "industry",
    author: "顾迟",
    publishedAt: "2026-08-18",
    readMinutes: 6,
    tags: ["行业内幕", "消费观察", "套路盘点"],
    views: 8210,
    cover:
      "https://readdy.ai/api/search-image?query=moody%20dark%20still%20life%20of%20an%20assortment%20of%20unlabeled%20product%20packages%20in%20deep%20shadow%20under%20a%20single%20warm%20light%2C%20crimson%20and%20amber%20tones%2C%20cinematic%20editorial%20photography%2C%20abstract%20consumer%20theme%2C%20high%20detail%2C%20no%20text&width=1200&height=750&seq=cover-iq-tax-review-01&orientation=landscape",
    content: [
      {
        type: "p",
        text: "“智商税”这个词带着情绪，但它描述的其实是一个很朴素的现象：人们愿意为确定感付出溢价，哪怕这个确定感并没有证据支撑。",
      },
      {
        type: "h2",
        text: "六种常见套路",
      },
      {
        type: "list",
        items: [
          "概念先行：用一个听不太懂的新名词建立专业感；",
          "权威借势：把不相关的头衔放在显眼位置；",
          "稀缺催促：限时、限量、只此一批；",
          "从众暗示：展示无法核实的销量或好评；",
          "焦虑放大：先把问题说得很严重，再给出唯一解；",
          "退路模糊：不谈效果标准，只谈“因人而异”。",
        ],
      },
      {
        type: "quote",
        text: "判断一个产品是否值得，关键不是它承诺了什么，而是它是否愿意为承诺设定可验证的标准。",
      },
      {
        type: "h2",
        text: "一个简单的自检方法",
      },
      {
        type: "p",
        text: "下次面对“很懂你”的推销时，试着问一句：如果我完全没有任何焦虑，它还会不会让我动心？如果答案是不会，那被安抚的其实是你，而不是被解决的问题。",
      },
    ],
  },
  {
    slug: "screenshot-context",
    title: "截图背后的真相：断章取义如何影响判断",
    subtitle: "一张图能说明什么，又能隐瞒什么",
    excerpt:
      "在信息传播里，截图是最有说服力也最容易被误读的证据。我们通过几个典型场景，说明为什么“有图”并不等于“有真相”。",
    channel: "internet",
    author: "周叙",
    publishedAt: "2026-08-15",
    readMinutes: 5,
    tags: ["网络迷雾", "信息分辨", "传播"],
    views: 6120,
    cover:
      "https://readdy.ai/api/search-image?query=moody%20abstract%20photo%20of%20a%20torn%20paper%20fragment%20isolated%20under%20a%20single%20warm%20light%20on%20a%20dark%20surface%2C%20deep%20shadows%2C%20crimson%20and%20amber%20tones%2C%20cinematic%20editorial%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1200&height=750&seq=cover-screenshot-context-01&orientation=landscape",
    content: [
      {
        type: "p",
        text: "截图之所以传播力强，是因为它看起来像“原始证据”。但截图本质上是一段被裁切过的文本，而裁切本身就是一种编辑。",
      },
      {
        type: "h2",
        text: "三种常见的裁切方式",
      },
      {
        type: "list",
        items: [
          "时间裁切：只保留最冲突的一段对话；",
          "对象裁切：隐去说话者，让责任显得无主；",
          "语境裁切：去掉前提条件，让结论看起来更极端。",
        ],
      },
      {
        type: "h2",
        text: "如何快速判断",
      },
      {
        type: "p",
        text: "看到一张只在情绪上成立、在逻辑上跳跃的截图时，可以先找两个信息：完整时间线，以及说话者的身份与场景。只要这两项缺失，结论就该先打个问号。",
      },
      {
        type: "quote",
        text: "图片不会说谎，但裁切会。",
      },
    ],
  },
];

export const getArticle = (slug: string): Article | undefined =>
  articles.find((a) => a.slug === slug);

export const featuredArticles = (): Article[] => articles.filter((a) => a.featured);

export const articlesByChannel = (channelSlug: string): Article[] =>
  articles.filter((a) => a.channel === channelSlug);

export const popularArticles = (limit = 5): Article[] =>
  [...articles].sort((a, b) => b.views - a.views).slice(0, limit);

export const latestArticles = (limit = 6): Article[] =>
  [...articles].sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1)).slice(0, limit);